import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Nav from './components/Nav';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import RequestAccessPage from './pages/RequestAccessPage';
import FAQPage from './pages/FAQPage';
import OnboardingPage from './pages/OnboardingPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import AvailabilityPage from './pages/AvailabilityPage';
import MagicLinkCallbackPage from './pages/MagicLinkCallbackPage';
import EmailVerificationPage from './pages/EmailVerificationPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SetupAccountPage from './pages/SetupAccountPage';
import AdminPage from './pages/AdminPage';
import './index.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>🍵</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/setup" replace />;
  return children;
}

function AppLayout({ children }) {
  return (
    <div className="page">
      <Nav />
      {children}
    </div>
  );
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>🍵</div>;

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/dashboard" /> : <LandingPage />} />
      <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <AuthPage mode="login" />} />
      <Route path="/request-access" element={user ? <Navigate to="/dashboard" /> : <RequestAccessPage />} />
      <Route path="/magic/callback" element={<MagicLinkCallbackPage />} />
      <Route path="/verify-email" element={<EmailVerificationPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/setup" element={<SetupAccountPage />} />
      <Route path="/onboarding" element={<PrivateRoute><OnboardingPage /></PrivateRoute>} />
      <Route path="/dashboard" element={<PrivateRoute><AppLayout><DashboardPage /></AppLayout></PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute><AppLayout><ProfilePage /></AppLayout></PrivateRoute>} />
      <Route path="/availability" element={<PrivateRoute><AppLayout><AvailabilityPage /></AppLayout></PrivateRoute>} />
      <Route path="/admin" element={<PrivateRoute><AppLayout><AdminPage /></AppLayout></PrivateRoute>} />
      <Route path="/faq" element={<PrivateRoute><AppLayout><FAQPage /></AppLayout></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
